import { combineEpics } from 'redux-observable'
import { createListable } from 'listable'
import options from './config'
import { createEffects } from './effects'
import * as customActions from './actions'
import { moduleName } from './actions/types'
import customReducer from './reducer'


const listableModule = createListable({
  name: moduleName,
  config: options,
  customActions,
  customReducer,
})

export const config = listableModule.options
export const actions = listableModule.actions

export const effects = combineEpics(
  createEffects(listableModule.actions),
  listableModule.effects,
)

export const name = listableModule.name
export const reducer = listableModule.reducer
export const types = listableModule.types

export const constants = {
  ...listableModule.constants,
  PATH_ALL: `/vehicle-summary`,
  PATH_ADD: `/vehicle-summary/new`,
  PATH_SINGLE: `/vehicle-summary/booking`,
  ROUTE_ALL: `/vehicle-summary`,
  ROUTE_ADD: `/vehicle-summary/new`,
  ROUTE_SINGLE: `/vehicle-summary/booking/:id`,

  PATH_LEASE_INFORMATION: `/lease_information`,
  PATH_VEHICLE_INFORMATION: `/vehicle_information`,
  PATH_ADDITIONAL_SERVICES: `/additional_services`,
  PATH_ACCESSORIES: `/accessories`,
}


export const createDefaultModel = () => ({
  effectiveDate: null,
  status: 'requested',
})
